<template>
  <v-card flat tile class="mb-4">
    <v-toolbar flat>
      <v-toolbar-title>{{postTitle||title}}<v-progress-circular v-show="loader.feeling" :size="16" color="purple"
          indeterminate></v-progress-circular>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu bottom right offset-y>
        <v-btn slot="activator" icon>
          <v-icon>more_horiz</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile>
            <v-list-tile-title @click="clearSelectFeel">Clear Voice Feeling</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-container fluid grid-list-lg>
      <v-layout row wrap voice-rating>
        <v-flex v-for="(item, index) in postFeelings||feelings" v-bind:key="index" @click="selectFeel(item)" :class="{ '': index === 0 }">
          <div class="text-xs-center">

            <v-btn fab dark :class="{grey: false}" :color="getIconColor(item)">
              <v-icon dark>{{item.btnicon}}</v-icon>
            </v-btn>

            <!-- <v-btn v-else-if="(selectedFeeling !=='' && selectedFeeling === item.text)" fab dark :color="item.btncolor"
              v-on:click.native="clearSelectFeel()">
              <v-icon dark>{{item.btnicon}} B</v-icon>
            </v-btn>

            <v-btn v-else-if="selectedFeeling!==''" fab dark color="grey" class="grey lighten-1" v-on:click.native="selectFeel(item)">
            </v-btn> -->

            <div class="feeling-label text-xs-center">{{item.text}}</div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
  import AppConst from '../AppConst.js'
  import { GetActivityByUserQuery, ListActivitiesForCurrentUser } from '@/components/queries'
  import { CreateActivityMutation, UpdateActivityMutation, DeleteActivityMutation } from '@/components/mutations'

  // import VocalActivityHome from './VocalActivityHome.vue'

  //@TODO: remove localStorage. check dependencies. 
  /* globals localStorage */
  localStorage.voiceFeelingSelected = ''
  if (!localStorage.voiceFeelingSelected) { localStorage.voiceFeelingSelected = '' }

  export default {
    data() {
      return {
        loader: {
          feeling: false
        },
        title: 'Voice Function/Feeling',
        selectedFeeling: localStorage.voiceFeelingSelected,
        feelings: AppConst.voiceFeelDefaults
      }
    },
    props: [
      'postTitle',
      'postFeelings'
    ],
    methods: {
      getIconColor(item) {
        if (this.selectedFeeling === '' || this.selectedFeeling === item.text) {
          return item.btncolor;
        } else {
          return 'grey';
        }
      },
      async refreshFeeling() {
        const feeling = await this.getUserVoiceFeeling();
        if (feeling !== null) {
          this.selectedFeeling = feeling.intensity
          localStorage.voiceFeelingSelected = feeling.intensity
          localStorage.totalDailyAllotment = feeling.value
          localStorage.currentDateVoiceFeelID = feeling.id
          localStorage.totalDailyAllotment = feeling.value
          this.totalDailyAllotment = localStorage.totalDailyAllotment
          this.vocalActivityValue = localStorage.vocalActivityTotal
        } else {
          this.selectedFeeling = ''
          this.selectedFeeling = ''
          localStorage.voiceFeelingSelected = ''
          localStorage.totalDailyAllotment = 0
          localStorage.currentDateVoiceFeelID = ''
          localStorage.totalDailyAllotment = 0
        }
        this.$root.$emit('voiceFeelChange', localStorage.totalDailyAllotment)
        this.totalDailyAllotment = localStorage.totalDailyAllotment
        this.vocalActivityValue = localStorage.vocalActivityTotal
      },
      // @TODO: replce this with a get. 
      // There should only be a single row for actDate and actiityType:VoiceFeeling
      async getUserVoiceFeeling() {
        const params = {
          variables: {
            actDate: localStorage.currentDate
          },
          query: ListActivitiesForCurrentUser
        }
        const result = await this.$apollo.query(params);
        const { items } = result.data.listActivitiesForCurrentUser;
        const feeling = items.filter(it => it.activityType === 'VoiceFeeling').pop() || null;
        return feeling;
      },
      async deleteAllVF() {
        console.log('delete allVF');
        const feel = await this.getUserVoiceFeeling();
        if (feel) {
          console.log('deleting', feel.id);
          await this.deleteVoiceFeeling(feel.id);
          await this.deleteAllVF();
        } else {
          console.log('nothing to delete');
          this.selectedFeeling = '';
        }
      },
      async deleteVoiceFeeling(activityID) {
        const result = await this.$apollo.mutate({
          variables: {
            input: {
              id: activityID
            }
          },
          mutation: DeleteActivityMutation
        });
      },
      async updateUserFeeling(item) {
        return await this.createUserFeeling(item);
        
        const input = {
          id: localStorage.subID + '--' + (new Date().getTime()),
          username: localStorage.subID,
          actDate: localStorage.currentDate,
          activityType: 'VoiceFeeling',
          timestamp: (new Date().getTime()),
          value: item.maxValue,
          intensity: item.text
        }
        const data = await this.$apollo.mutate({
          variables: {
            input
          },
          mutation: UpdateActivityMutation
        });
      },
      async createUserFeeling(item) {
        // myitem=AppConst.voiceFeelDefaults.filter( item.text=='VoiceFeeling')
        // gather inputs
        const input = {
          id: localStorage.subID + '--' + (new Date().getTime()),
          username: localStorage.subID,
          actDate: localStorage.currentDate,
          activityType: 'VoiceFeeling',
          timestamp: (new Date().getTime()),
          value: item.maxValue,
          intensity: item.text
        }
        // add to dynamodb
        const data = await this.$apollo.mutate({
          variables: {
            input
          },
          mutation: CreateActivityMutation
        })
        return data;
      },
      async selectFeel(item) {
        console.log("selectFeel", item.text );
        this.loader.feeling = true;
        this.selectedFeeling = item.text
        localStorage.voiceFeelingSelected = item.text

        await this.deleteAllVF();
        console.log('removed old activity for voice feeling for the selected date');

        const { data } = await this.createUserFeeling(item);
        const feel = data.createActivity;
        console.log('new feel', feel);
        if (feel) {
          this.selectedFeeling = feel.intensity
          localStorage.voiceFeelingSelected = feel.intensity
          localStorage.totalDailyAllotment = feel.value
          localStorage.currentDateVoiceFeelID = feel.id
          console.log('emit voiceFeelChange', feel);
          this.$root.$emit('voiceFeelChange', feel);
        } else {
          console.log('unable to create activity');
        }
        this.loader.feeling = false;
      },
      async clearSelectFeel() {
        console.debug("clearSelectFeel");
        await this.deleteAllVF();
        this.selectedFeeling = ''
        localStorage.voiceFeelingSelected = ''
        localStorage.currentDateVoiceFeelID = ''
        localStorage.totalDailyAllotment = 0
        this.$root.$emit('voiceFeelChange', localStorage.totalDailyAllotment)
      }
    },
    created() {
      /*
      var that=this;
      console.log("created feel");
      getUserVoiceFeeling(that, function(data){
          var item=filterUserFeeling(data);
          if(item!=null){
            that.selectedFeeling = item.intensity;
            localStorage.voiceFeelingSelected=item.intensity;
            localStorage.totalDailyAllotment=item.value;
            localStorage.currentDateVoiceFeelID=item.id;
            localStorage.totalDailyAllotment=item.value;
            that.totalDailyAllotment=localStorage.totalDailyAllotment;
            that.vocalActivityValue=localStorage.vocalActivityTotal;
          }
   
      });
      this.$root.$on('DateChange', data => {
              localStorage.currentDate=data;
              getUserVoiceFeeling(that, function(data){
                  var item=filterUserFeeling(data);
                  if(item!=null){
                    that.selectedFeeling = item.intensity;
                    localStorage.voiceFeelingSelected=item.intensity;
                    localStorage.totalDailyAllotment=item.value;
                    localStorage.currentDateVoiceFeelID=item.id;
                    localStorage.totalDailyAllotment=item.value;
                  that.$root.$emit('voiceFeelChange', localStorage.totalDailyAllotment);
                  that.totalDailyAllotment=localStorage.totalDailyAllotment;
                  that.vocalActivityValue=localStorage.vocalActivityTotal;
                  }
   
              });
      });
    */
    },
    async mounted() {
      await this.refreshFeeling();

      this.$root.$on('DateChange', date => {
        localStorage.currentDate = date
        this.refreshFeeling();
      });


    },
    beforeDestroy() {
      this.$root.$off('DateChange')
    }
  }
</script>
<style lang="css">
  @import '/styles.css';
</style>
<style>
  @media all and (max-width: 540px) {
    .container.grid-list-lg .voice-rating .flex {
      padding: 8px 2px;
    }

    .voice-rating .feeling-label {
      font-size: 10px;
      max-width: 55px;
      margin: auto;
    }

    .voice-rating .btn {
      margin: 5px 0px;
    }

  }
</style>


// WEBPACK FOOTER //
// src/components/home/VoiceFeelHome.vue